import SidebarNavRail from './SidebarNavRail';

export default SidebarNavRail;
